/**
 * Den Servicearbeiter anmelden - und wissen, wann man es NICHT tut.
 *
 * Er ist das Stück, das aus der Seite eine App macht: erst mit ihm bietet
 * Chrome "Installieren" an, und danach läuft die Anwendung in einem eigenen
 * Fenster ohne Adresszeile.
 *
 * Drei Fälle, in denen er nichts zu suchen hat:
 *
 *  - ELECTRON. Dort lädt die Anwendung über `file://`. Servicearbeiter gibt
 *    es dort gar nicht, und der Aufruf endet in einer Ausnahme, die niemand
 *    fängt - beim Start der Desktopfassung, also an der schlechtesten
 *    denkbaren Stelle.
 *  - DIE ENTWICKLUNGSMASCHINE. Ein Arbeiter, der Dateien aufhebt, und ein
 *    Vite, das sie bei jeder Änderung neu ausliefert, widersprechen sich.
 *    Man sucht dann Fehler, die man selbst zwischengelagert hat. Zum Prüfen
 *    gibt es `vite preview`, das baut wie im Betrieb.
 *  - EIN BROWSER OHNE UNTERSTÜTZUNG. Dann bleibt es eine gewöhnliche Seite,
 *    die vollständig funktioniert. Die App ist ein Zugewinn, keine
 *    Voraussetzung.
 */

/** Läuft das hier über das Netz - oder aus einer Datei (Electron)? */
export function ueberDasNetz(ort = globalThis.location) {
  return ort?.protocol === 'https:' || ort?.protocol === 'http:';
}

export function registriereServicearbeiter({
  navigator: nav = globalThis.navigator,
  ort = globalThis.location,
  imBetrieb = import.meta.env?.PROD,
  logger = console,
} = {}) {
  if (!imBetrieb || !ueberDasNetz(ort) || !nav || !('serviceWorker' in nav)) {
    return Promise.resolve(null);
  }
  return nav.serviceWorker
    .register('/sw.js', { scope: '/' })
    .catch((fehler) => {
      /* Ein gescheiterter Arbeiter darf die Anwendung nicht aufhalten. Sie
         funktioniert ohne ihn vollständig - man kann sie dann nur nicht
         installieren. */
      logger?.warn?.('Servicearbeiter nicht angemeldet:', fehler?.message || fehler);
      return null;
    });
}

/**
 * Das Lager leeren - beim Abmelden.
 *
 * Es liegen dort ausdrücklich keine Daten, die jemandem gehören (siehe
 * `public/sw.js`). Der Weg wird trotzdem gerufen: würde dort je etwas
 * landen, das an eine Person gebunden ist, wäre die Abmeldung die Stelle,
 * an der es verschwinden muss - und diese Stelle soll dann schon existieren
 * und nicht erst gesucht werden.
 */
export function leereLager({ navigator: nav = globalThis.navigator } = {}) {
  const arbeiter = nav?.serviceWorker?.controller;
  if (arbeiter) {
    arbeiter.postMessage('lager-leeren');
  }
}
